import { ICSVFormat } from "../../models/csv_format.ts";
import { ICreateArticle, IUpdateArticle } from "../../models/article.ts";

export const transformFromCSVToArticle = (
  csv: ICSVFormat,
  formatBodyForArticle: (body: string) => string,
  locale: string = "ja",
): ICreateArticle | IUpdateArticle => {
  const baseArticle = {
    title: csv.title,
    body: formatBodyForArticle(csv.body),
    draft: csv.draft,
    attachment_names: getAttachmentNames(csv),
    label_names: getLabelNames(csv),
    content_tag_ids: getContentTagIds(csv),
    locale: locale,
    section_id: csv.section_id,
    permission_group_id: csv.permission_group_id,
    user_segment_id: csv.user_segment_id,
  };

  return csv.id === null || csv.id === undefined
    ? (baseArticle as ICreateArticle)
    : ({
        ...baseArticle,
        id: csv.id,
        author_id: csv.author_id!,
        html_url: "",
        created_at: csv.created_at!,
        updated_at: csv.updated_at!,
      } as IUpdateArticle);
};

export const getAttachmentNames = (csv: ICSVFormat) => {
  const paths = [
    csv.attachment_name1,
    csv.attachment_name2,
    csv.attachment_name3,
    csv.attachment_name4,
    csv.attachment_name5,
  ];
  return paths.filter(
    (path): path is string => typeof path === "string" && path !== "",
  );
};

export const getLabelNames = (csv: ICSVFormat) => {
  const paths = [
    csv.label_name1,
    csv.label_name2,
    csv.label_name3,
    csv.label_name4,
    csv.label_name5,
    csv.label_name6,
    csv.label_name7,
    csv.label_name8,
    csv.label_name9,
    csv.label_name10,
  ];
  return paths.filter(
    (path): path is string => typeof path === "string" && path !== "",
  );
};

export const getContentTagIds = (csv: ICSVFormat) => {
  const paths = [
    csv.content_tag_id1,
    csv.content_tag_id2,
    csv.content_tag_id3,
    csv.content_tag_id4,
    csv.content_tag_id5,
  ];
  return paths.filter(
    (path): path is string => typeof path === "string" && path !== "",
  );
};
